import type { ReactNode } from 'react';
import { createContext } from 'react';

type PermissionsContextValue = Record<string, never>;

export const PermissionsContext = createContext<PermissionsContextValue | null>(
  null,
);

export type PermissionsProviderProps = {
  children: ReactNode;
};
